module.exports = __webpack_public_path__ + "img/hy.a4bddde8.jpg";